var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRevertWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17236_332864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.833008 3.55603V8.55603M0.833008 8.55603H5.83301M0.833008 8.55603L4.69967 4.9227C5.85043 3.77388 7.34338 3.03017 8.95357 2.80363C10.5638 2.57708 12.204 2.87997 13.627 3.66667C15.0501 4.45336 16.179 5.68123 16.8435 7.16528C17.5081 8.64933 17.6723 10.3092 17.3115 11.8947C16.9507 13.4802 16.0844 14.9055 14.8431 15.9558C13.6018 17.0062 12.0528 17.6247 10.4294 17.7181C8.80608 17.8115 7.19632 17.3748 5.84272 16.4738C4.48912 15.5728 3.465 14.2563 2.92467 12.7227",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17236_332864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.222656)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRevertWhite);
export default __webpack_public_path__ + "static/media/revertWhite.c437e0d158d868b4d4370afbac958006.svg";
export { ForwardRef as ReactComponent };